import { ConfirmationPage, GuestCheck, Service, Service1356 } from './pages'
import GuestCheck1356 from './pages/GuestCheck1356'
import {
  CHECK_PATH,
  CHECK_PATH_SMS_RADAR,
  CHECK_PATH_LANG_PARAM,
  CHECK_PATH_LANG_PARAM_SMS_RADAR,
  SERVICE_PATH,
  SERVICE_PATH_SMS_RADAR,
  SERVICE_PATH_LANG_PARAM,
  SERVICE_PATH_LANG_PARAM_SMS_RADAR,
  CONFIRMATION_PATH,
  CONFIRMATION_PATH_LANG_PARAM,
} from './utils/consts'

export const Routing = [
  {
    path: SERVICE_PATH,
    Element: <Service />,
  },
  {
    path: SERVICE_PATH_LANG_PARAM,
    Element: <Service />,
  },
  {
    path: SERVICE_PATH_SMS_RADAR,
    Element: <Service1356 />,
  },
  {
    path: SERVICE_PATH_LANG_PARAM_SMS_RADAR,
    Element: <Service1356 />,
  },
  {
    path: CONFIRMATION_PATH,
    Element: <ConfirmationPage />,
  },
  {
    path: CONFIRMATION_PATH_LANG_PARAM,
    Element: <ConfirmationPage />,
  },
  {
    path: CHECK_PATH,
    Element: <GuestCheck />,
  },
  {
    path: CHECK_PATH_LANG_PARAM,
    Element: <GuestCheck />,
  },
  {
    path: CHECK_PATH_SMS_RADAR,
    Element: <GuestCheck1356 />,
  },
  {
    path: CHECK_PATH_LANG_PARAM_SMS_RADAR,
    Element: <GuestCheck1356 />,
  },
]
